export default "__VITE_ASSET__BEYxpOu2__"